import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { generateConfig } from "../../utils/api";
import { handleApiError } from "../../utils/apiErrorHandler";

export const createResourceSchedule = createAsyncThunk(
  "resourceSchedules/createResourceSchedule",
  async (
    { clinicId, scheduleData },
    { rejectWithValue, getState, dispatch }
  ) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });
    try {
      const response = await axios.post(
        `${baseURL}/api/clinics/${clinicId}/resource-schedules`,
        scheduleData,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const fetchResourceSchedules = createAsyncThunk(
  "resourceSchedules/fetchResourceSchedules",
  async (
    { clinicId, startDate, endDate },
    { rejectWithValue, getState, dispatch }
  ) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });
    try {
      const response = await axios.get(
        `${baseURL}/api/clinics/${clinicId}/resource-schedules`,
        {
          ...config,
          params: { startDate, endDate },
        }
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const updateResourceSchedule = createAsyncThunk(
  "resourceSchedules/updateResourceSchedule",
  async (
    { clinicId, scheduleId, scheduleData },
    { rejectWithValue, getState, dispatch }
  ) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });
    try {
      const response = await axios.patch(
        `${baseURL}/api/clinics/${clinicId}/resource-schedules/${scheduleId}`,
        scheduleData,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const deleteResourceSchedule = createAsyncThunk(
  "resourceSchedules/deleteResourceSchedule",
  async ({ clinicId, scheduleId }, { rejectWithValue, getState, dispatch }) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });
    try {
      const response = await axios.delete(
        `${baseURL}/api/clinics/${clinicId}/resource-schedules/${scheduleId}`,
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const checkResourceAvailability = createAsyncThunk(
  "resourceSchedules/checkResourceAvailability",
  async (
    { clinicId, start, duration },
    { rejectWithValue, getState, dispatch }
  ) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });
    try {
      const response = await axios.post(
        `${baseURL}/api/clinics/${clinicId}/resource-schedules/check-availability`,
        { start, duration },
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

// Add resource to appointment
export const addResourceToAppointment = createAsyncThunk(
  "resourceSchedules/addResourceToAppointment",
  async (
    { clinicId, appointmentId, resourceId, start, end, title },
    { rejectWithValue, getState, dispatch }
  ) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });
    try {
      const response = await axios.post(
        `${baseURL}/api/clinics/${clinicId}/appointment-resources`,
        {
          appointment: appointmentId,
          resource: resourceId,
          start,
          end,
          title,
        },
        config
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

// Remove resource from appointment
export const removeResourceFromAppointment = createAsyncThunk(
  "resourceSchedules/removeResourceFromAppointment",
  async (
    { clinicId, appointmentId, resourceId },
    { rejectWithValue, getState, dispatch }
  ) => {
    const state = getState();
    const token = state.auth.token;
    const { baseURL, config } = generateConfig({ token });
    try {
      const response = await axios.delete(
        `${baseURL}/api/clinics/${clinicId}/appointment-resources`,
        {
          ...config,
          data: {
            appointment: appointmentId,
            resource: resourceId,
          },
        }
      );
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);
